import type { InputHTMLAttributes } from "react";
import { tw } from "@/lib/theme";

interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

export function TextField({ label, error, id, className = "", ...props }: TextFieldProps) {
  const fieldId = id ?? label.toLowerCase().replace(/\s+/g, "-");
  return (
    <label className="flex w-full flex-col gap-1.5 text-sm">
      <span className="font-medium text-ink dark:text-dark-ink">{label}</span>
      <input
        id={fieldId}
        className={[
          tw.input,
          error ? "border-red-500" : "",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
        {...props}
      />
      {error ? <span className="text-xs text-red-600">{error}</span> : null}
    </label>
  );
}
